export const teacher = [
  { title: "Преподаватель", type: "title" },
  {
      type: "list",
      title: "Эссе",
      icon: "doc-text-icon",
      links: [
         {
         type: "link",
         title: "Промпты",
         icon: "circle-icon",
         name: "prompts",
         },
         {
         type: "link",
         title: "Курсы",
         icon: "circle-icon",
         name: "courses",
         },
         {
         type: "link",
         title: "Результаты",
         icon: "circle-icon",
         name: "results",
         },
      ],
    },
{
    type: "list",
    title: "Расписание",
    icon: "calendar",
    links: [
          {
           type: "link",
           title: "Расписание",
           icon: "circle-icon",
           name: "schedule",
           },
    ],
  },
];
